{
  "global": {
    "signedUp": "angemeldet",
    "signedUpPlural": "Angemeldete",
    "signUp": "Anmelden",
    "optOut": "Abmelden",
    "youAreSignedUp": "Sie sind jetzt angemeldet",
    "youOptedOut": "Sie sind jetzt abgemeldet",
    "youAreLoggedIn": "Sie sind jetzt eingeloggt",
    "logOut": "Ausloggen",
    "signingUp": "Anmelden",
    "optingOut": "Abmelden",
    "today": "Heute",
    "dateDisplayAbbr": "D.",
    "timeOfDayAbbr": "Uhr",
    "now": "Jetzt",
    "showToday": "Heute anzeigen",
    "showAll": "Alle anzeigen",
    "showProfile": "Profil anzeigen",
    "choose": "Auswählen",
    "startDate": "Anfangsdatum",
    "startTime": "Anfangszeit",
    "starts": "Fängt an",
    "started": "Läuft jetzt",
    "startedAlready": "Angefangen",
    "cancelled": "Annulliert",
    "duration": "Dauer",
    "endTime": "Endet um",
    "endDate": "Endet am",
    "timeTo": "Über",
    "day": "Tag",
    "days": "Tage",
    "hour": "Stunde",
    "hours": "Stunden",
    "hoursAbbr": "h",
    "minutes": "m",
    "tomorrow": "Morgen",
    "location": "Standort",
    "document": "Dokument",
    "documents": "Dokumente",
    "images": "Fotos",
    "imagesAndVideos": "Fotos und Videos",
    "additionalProfiles": "mehr",
    "passedDeadline": "An- und Abmeldung geschlossen",
    "close": "Schließen",
    "completed": "Fertig",
    "fromDate": "Ab",
    "toDate": "An",
    "date": "Datum",
    "oclock": "Uhrzeit",
    "week": "Woche",
    "thisWeek": "Diese Woche",
    "goToThisWeek": "Zu dieser Woche gehen",
    "goToToday": "Zu Heute gehen",
    "all": "Alle",
    "seeAll": "Alle anzeigen",
    "remaining": "Die Übrigen",
    "participate": "Teilnehmer",
    "participantsPlural": "Teilnehmer",
    "participants": "Teilnehmer",
    "responsible": "Verantwortliche",
    "responsiblePlural": "Verantwortliche",
    "signUpDeadline": "An-/Abmeldefrist in",
    "signUpExpired": "An-/Abmeldefrist abgelaufen",
    "maxSignupsReached": "Keine Plätze mehr frei",
    "readMore": "Weiterlesen",
    "genitive": "s",
    "nothingToShow": "Es gibt nichts zu zeigen",
    "waitingForResponse": "Wartet auf Antwort...",
    "tts": "vorlesen",
    "startButton": "anfangen",
    "backButton": "Zurück",
    "backTo": "Zurück zu",
    "errorOccured": "Es ist ein Fehler aufgetreten. Erneut versuchen...",
    "weekdayMonday": "Montag",
    "weekdayTuesday": "Dienstag",
    "weekdayWednesday": "Mittwoch",
    "weekdayThursday": "Donnerstag",
    "weekdayFriday": "Freitag",
    "weekdaySaturday": "Samstag",
    "weekdaySunday": "Sonntag",
    "weekdayMondayAbbr": "Mo",
    "weekdayTuesdayAbbr": "Di",
    "weekdayWednesdayAbbr": "Mi",
    "weekdayThursdayAbbr": "Do",
    "weekdayFridayAbbr": "Fr",
    "weekdaySaturdaydayAbbr": "Sa",
    "weekdaySunddayAbbr": "So",
    "MONDAY": "Montag",
    "TUESDAY": "Dienstag",
    "WEDNESDAY": "Mittwoch",
    "THURSDAY": "Donnerstag",
    "FRIDAY": "Freitag",
    "SATURDAY": "Samstag",
    "SUNDAY": "Sonntag",
    "autoplay": "Autoplay",
    "stop": "Stop",
    "play": "Abspielen",
    "pause": "Pause",
    "restart": "Neu starten",
    "cancel": "Abbrechen",
    "description": "Beschreibung",
    "error": "Fehler",
    "tryAgain": "Erneut versuchen",
    "obs": "Info",
    "somethingWentWrong": "Es ist ein Fehler aufgetreten",
    "nightShift": "Nachtschicht",
    "backToNow": "Zurück zu jetzt",
    "switchUser": "Benutzer wechseln",
    "noDescription": "Keine Beschreibung",
    "about": "rund um",
    "busy": "Beschäftigt",
    "departments": "Abteilungen",
    "dishes": "Teilgerichten",
    "employee": "Mirarbejder",
    "ends": "Ende",
    "enterPinToAccess": "Geben Sie Ihren Code ein, um Zugang zu erhalten.",
    "error_suggestion": "Bitte versuchen Sie es erneut",
    "galleries": "Galerien",
    "info": "Info",
    "institution": "Einrichtung",
    "lastUpdateMinutes": "Aktualisiert vor {n} Minuten",
    "loading": "Denken...",
    "pictograms": "Piktogramme",
    "repeats": "Wiederholt",
    "reset": "Zurücksetzen",
    "resident": "Bürger",
    "selectDepartment": "Abteilung ändern",
    "signupNotNeeded": "Anmeldung nicht erforderlich",
    "sort": "Ansicht sortieren",
    "stopAutoplay": "Automatische Wiedergabe stoppen",
    "title": "Titel",
    "uncategorized": "unkategorisiert",
    "use": "Anwenden",
    "videos": "Videos"
  },
  "moduleNames": {
    "ACTIVITIES": "Aktivitäten",
    "BOOKING": "Buchung",
    "EXTERNAL_ACTIVITIES": "Externe Aktivitäten",
    "GALLERY": "Galerien",
    "JOURNEY_PLANNER": "Reiseplan",
    "MEAL_PLAN": "Speiseplan",
    "MEETINGS": "Treffen",
    "NEWS": "Neuigkeiten",
    "OUR_HOME": "Über uns",
    "SIMPLE_WORK_SCHEDULE": "Dienstplan",
    "WAYFINDER": "Wegweiser",
    "WEATHER": "Wetter",
    "WORK_SCHEDULE": "Dienstplan",
    "CALENDAR": "Kalender",
    "BOOKING_ENTRY": "Buchung",
    "BOOKING_RESOURCE_ENTRY": "Buchung",
    "BOOKING_RESOURCES": "Buchung"
  },
  "activities": {
    "moduleName": "Aktivitäten",
    "noActivities": "Keine Aktivitäten",
    "noActivitiesDescription": "Es gibt keine Aktivitäten zu zeigen...",
    "noVacancy": "Keine Plätze mehr frei",
    "vacation": "Urlaub",
    "clubs": "Klubs",
    "noClubs": "Es gibt keine Klubs zu zeigen...",
    "optedOut": "Sie sind jetzt von der Aktivität abgemeldet.",
    "optOut": "Geben Sie Ihren Code ein, um sich von der Aktivität abzumelden.",
    "signedUp": "Sie sind nun für die Aktivität registriert.",
    "signUp": "Geben Sie Ihren Code ein, um sich für die Aktivität zu registrieren."
  },
  "externalActivities": {
    "moduleName": "Externe Aktivitäten"
  },
  "activity": {
    "moduleName": "Aktivität",
    "organizer": "Organisiert von",
    "price": "Preis",
    "currencyAbbr": "EUR",
    "responsible": "Verantwortliche",
    "responsiblePlural": "Verantwortliche",
    "noSeatsLeft": "Keine Plätze mehr frei",
    "oneSeatLeft": "Platz frei",
    "moreSeatsLeft": "Plätze frei",
    "theActivity": "Die Aktivität",
    "alreadySignedOff": "Sie sind bei der Aktivität nicht angemeldet",
    "alreadySignedUp": "Sie sind bei der Aktivität schon angemeldet"
  },
  "booking": {
    "moduleName": "Buchung",
    "moduleHeaderOverview": "Buchungsübersicht",
    "moduleHeaderResources": "Was möchten Sie buchen?",
    "noBookings": "Es sind keine Buchungen erstellt",
    "noResources": "Es gibt keine Buchungen zu zeigen...",
    "inUseNow": "Bereits in Nutzung",
    "overview": "Übersicht",
    "newBooking": "Neue Buchung",
    "book": "Buchen",
    "errorTimeSetting": "Fehler bei der Zeiteinstellung. Startdatum/-zeit ist nach Schlussdatum/-zeit.",
    "ressourceNotAvailable": "Die Ressource ist im gewählten Zeitraum nicht verfügbar.",
    "ressourceNoLongerAvailable": "Die Ressource ist nicht mehr verfügbar. Erneut versuchen...",
    "chooseParticipants": "Mindestens eine Person wählen, dann SPEICHERN drücken",
    "bookingCreated": "Buchung erstellt",
    "bookingDeleted": "Buchung gelöscht",
    "deletingBooking": "Buchung löschen",
    "returnToBooking": "Zurück zur Buchung",
    "action": "buchen",
    "addDescription": "Beschreibung hinzufügen?",
    "selectParticipantsTitle": "Mit wem?",
    "selecttParticipantsDescription": "Mindestens eine Person wählen, dann SPEICHERN drücken",
    "toBook": "buchen",
    "theBooking": "Die Buchung",
    "doubleBooking": "Hoppla, eine zweite Buchung wird gerade erstellt.",
    "chooseDifferentTime": "Bitte eine andere Zeit für die Buchung wählen",
    "confirmBooking": "Buchung bestätigen",
    "allBookings": "Alle Buchungen",
    "bookResource": "Geben Sie Ihren Code ein, um zu buchen.",
    "cancelBooking": "Geben Sie Ihren Code ein, um die Buchung zu stornieren.",
    "completed": "Die Buchung ist abgeschlossen.",
    "existingBookings": "Bestehende Buchungen",
    "noSchema": "Kein Schema erstellt",
    "times": "Mal"
  },
  "documents": {
    "moduleName": "Dokumente",
    "noDocuments": "Es gibt keine Dokumente zu zeigen..."
  },
  "employee": {
    "workingNow": "Jetzt bei der Arbeit!",
    "working": "Bei der Arbeit",
    "shift_conflict": "En medarbejder kan kun have én vagt om dagen pr. vagtplan."
  },
  "gallery": {
    "moduleName": "Galerien",
    "noGalleries": "Es gibt keine Galerien zu zeigen...",
    "galleryAccess": "Zugang zu den Galerien bekommen",
    "enterPinTitle": "Geben Sie Ihren Code ein, um auf die Galerie zuzugreifen."
  },
  "media": {
    "addToMy": {
      "pictures": "Meine Fotos hinzufügen",
      "videos": "Meine Videos hinzufügen",
      "documents": "Meine Dokumente hinzufügen"
    },
    "addedToMy": {
      "pictures": "Unter Meine Fotos hinzugefügt",
      "videos": "Unter Meine Videos hinzugefügt",
      "documents": "Zu meinen Dokumenten hinzugefügt"
    },
    "removeFromMy": {
      "pictures": "Von Meine Fotos entfernen",
      "videos": "Von Meine Videos entfernen",
      "documents": "Von Meinen Dokumenten entfernen"
    },
    "removedFromMy": {
      "pictures": "Von Meine Fotos entfernt",
      "videos": "Von Meine Videos entfernt",
      "documents": "Von Meinen Dokumenten entfernt"
    },
    "noImages": "Es gibt keine Fotos zu zeigen...",
    "noVideos": "Es gibt keine Videos zu zeigen...",
    "noDocuments": "Es gibt keine Dokumente zu zeigen...",
    "myDocuments": "Meine Dokumente",
    "myGalleries": "Meine Galerien",
    "myImages": "Meine Bilder",
    "myVideos": "Meine Videos"
  },
  "meals": {
    "moduleName": "Speiseplan",
    "eating": "isst mit",
    "noMenu": "es gibt kein Menü für",
    "noMenuDay": "Es wurde kein Menü erstellt für ",
    "theMeal": "Die Mahlzeit",
    "noMeals": "Keine Mahlzeiten",
    "noMealsDescription": "Es gibt keine Mahlzeiten zu zeigen...",
    "alreadySignedUp": "Sie sind der Mahlzeit schon angemeldet",
    "alreadySignedOff": "Sie sind der Mahlzeit nicht angemeldet",
    "optedOut": "Sie sind nun vom Essen abgemeldet.",
    "optOut": "Geben Sie Ihren Code ein, um sich vom Essen abzumelden.",
    "signedUp": "Sie sind nun für das Essen angemeldet.",
    "signUp": "Geben Sie Ihren Code ein, um sich für das Essen anzumelden."
  },
  "meeting": {
    "agenda": "Agenda",
    "agendaPoints": "Agenda - {amount} Punkte",
    "moduleName": "Treffen",
    "daysLeft": "Zurück",
    "noAgenda": "Keine Punkte auf der Agenda...",
    "suggestionItems": "{n} Vorschläge | {n} Vorschlag | {n} Vorschläge",
    "suggestion": "Vorschläge",
    "suggestions": "Vorschläge zur Agenda",
    "moreSuggestions": "Weitere Vorschläge",
    "writeSuggestion": "Vorschlag schreiben",
    "suggestionSaved": "Der Vorschlag wurde gespeichert",
    "returnToMeeting": "Zurück zur Treffen",
    "theMeeting": "Das Treffen",
    "noMeetingsDescription": "Es gibt keine Treffen zu zeigen...",
    "alreadySignedUp": "Sie sind bei der Treffen schon angemeldet",
    "toSuggest": "Vorschlag zur Treffen schreiben",
    "agendaPointss": "Tagesordnung – Ein Punkt",
    "agendaPointss_plural": "Tagesordnung – {amount} Punkte",
    "alreadySignedOff": "Sie sind bei der Treffen nicht angemeldet",
    "category": "Kategorie",
    "noSuggestionsYet": "Noch keine Vorschläge",
    "tts_agenda_point": "Artikel {number} : {title}",
    "tts_user_suggestion": "Vorschlag von {user} : {suggestion}"
  },
  "modals": {
    "login": "Einloggen",
    "loginText": "Wählen Sie sich selbst aus der Liste aus",
    "isSignedUp": "angemeldet",
    "allResidentsIn": "Alle Bürger in",
    "allEmployeesIn": "Alle Mitarbeiter in",
    "save": "Speichern",
    "delete": "Löschen",
    "wrongPassword": "Falsches Passwort",
    "myPictures": "Fotos von mir",
    "myTags": "In diesen Fotos bin ich getaggt",
    "returnToPicture": "Zurück zu Fotos",
    "whoIsTagged": "Wer ist auf das Foto",
    "whoIsTaggedText": "Personen auf das Foto wählen und SPEICHERN drücken",
    "documentError": "Das Dokument konnte nicht abgerufen werden!",
    "writePassword": "Passwort eingeben um ",
    "writePasswordSuggestion": "Vorschläge schreiben für ",
    "writePasswordEdit": "bearbeiten ",
    "writePasswordOptin": "Anmelden ",
    "writePasswordOptout": "Abmelden ",
    "youAreBooking": "Sie sind dabei zu buchen ",
    "ressourcePurpose": "Wofür soll die Ressource verwendet werden?",
    "searchResident": "Bürger*in suchen",
    "keyboardDelete": "LÖSCHEN",
    "keyboardSpace": "Leerzeichen",
    "logOn": "Einloggen",
    "next": "Weiter",
    "skip": "Überspringen",
    "writeYourSuggestion": "Schreiben Sie ihren Vorschlag",
    "emptyString": "Text leer",
    "passwordLocked": "Das Passwort wurde aus Sicherheitsgründen gesperrt. Versuchen Sie es in {amount} erneut",
    "tooManyAttempts": "ZU VIELE VERSUCHE",
    "tooManyAttemptsTryAgain": "Bitte versuchen Sie es in {minutes} Minuten erneut."
  },
  "news": {
    "moduleName": "Neuigkeiten",
    "noNews": "Keine Neuigkeiten",
    "noNewsDescription": "Es gibt keine Neuigkeiten zu zeigen...",
    "published": "Veröffentlicht: "
  },
  "ourHome": {
    "moduleName": "Über uns",
    "videoPresentation": "Videopräsentation",
    "presentation": "Präsentation",
    "noPresentation": "es gibt keine Präsentation",
    "galleries": "Galerien",
    "videos": "Videos",
    "documents": "Dokumente",
    "noDocuments": "Es gibt keine Dokumente",
    "noResidents": "Keine Bürger in",
    "noEmployees": "Keine Mitarbeiter in",
    "residents": "Bürger",
    "employees": "Mitarbeiter",
    "noMeetings": "Es gibt keine zukünftigen Treffen...",
    "dayLeft": "Tag übrig",
    "daysLeft": "Tage übrig",
    "iAmTagged": "In diesen Fotos bin ich getaggt"
  },
  "resident": {
    "homeDays": "Abwesenheit",
    "birthdayToday": "hat heute Geburtstag!",
    "myPictures": "Meine Fotos",
    "noVideos": "Es gibt keine Videos zu zeigen...",
    "resident": "Bürger*in"
  },
  "scheduleShift": {
    "moduleName": "Dienstplan",
    "noShifts": "Keine Dienste erstellt",
    "noShiftsToday": "Keiner arbeitet heute",
    "options": "Sie haben drei Optionen",
    "cancel": "stonieren",
    "cancelShift": "Dienst absagen",
    "shiftCancelled": "Der Dienst ist abgesagt",
    "cancelShiftHelpText": "Der Dienst wird gedimmt angezeigt. Kann später rückgängig gemacht werden.",
    "annullCancelation": "Absage abbrechen",
    "annullCancelationHelpText": "Dienst wieder normal anzeigen.",
    "delete": "Löschen",
    "deleteShift": "Dienst löschen",
    "deleteShiftHelpText": "Der Dienst wird gelöscht. Der Vorgang kann nicht rückgängig gemacht werden.",
    "deleteConfirmPreName": "Sie sind dabei folgendes zu löschen ",
    "deleteConfirmPostName": "Dienst. Sind Sie sicher, dass Sie löschen wollen? Der Vorgang kann nicht rückgängig gemacht werden.",
    "confirmDeleteButton": "Löschung bestätigen",
    "replace": "Ersetzen",
    "swap": "ersetzen",
    "replaceShift": "Dienst ersetzen",
    "replaceShiftChooseText": "Mitarbeiter*in wählen, der/die den Dienst ersetzen soll",
    "replaceShiftHelpText": "Der Dienst wird andere Mitarbeiter zugestellt. Kann hinterher rückgängig gemacht werden.",
    "replaceWith": "Ersetze mit ",
    "returnToScheduleShift": "Zurück zum Dienstplan",
    "inaccessible": "Nicht zugänglich",
    "workingNow": "Wer ist bei der Arbeit?",
    "workingLater": "Kommt später",
    "noOneWorkingNow": "Keiner ist bei der Arbeit im Moment...",
    "noOneComing": "Keiner kommt später...",
    "editScheduleShift": "Sie können jetzt den Dienstplan bearbeiten",
    "theScheduleShift": "Dienstplan",
    "shiftFor": "der Dienst für",
    "cancelText": "stonieren",
    "cancelButton": "Stonier",
    "reactivateButton": "Reaktivier",
    "confirmCancelationButton": "Stornierung bestätigen",
    "confirmReactivationButton": "Reaktivierung bestätigen",
    "editShiftButton": "Dienst bearbeiten",
    "editNotAllowed": "Sie müssen Mitarbeiter sein, um den Dienstplan zu bearbeiten. Bitte setzen Sie den Bildschirm zurück, indem Sie zum Hauptbildschirm navigieren und versuchen es erneut.",
    "notComing": "Kommt nicht",
    "reactivate": "reaktivieren"
  },
  "calendar": {
    "moduleName": "Kalender"
  },
  "system": {
    "connectionError": "Verbindungsfehler",
    "connectionErrorText": "Das System versucht die Verbindung wiederherzustellen...",
    "connectionErrorHelpText": "Das System benötigt weitere Informationen um zu funktionieren. In 10 Sekunden werden Sie zur Login-Seite weitergeleitet.",
    "testConnection": "Verbindung testen",
    "logOut": "Ausloggen",
    "menu": "Menü"
  },
  "travelPlan": {
    "moduleName": "Reiseplan"
  },
  "wayfinder": {
    "moduleName": "Weg finden",
    "youAreHere": "Sie sind hier",
    "groundFloor": "Erdgeschoss",
    "xFloor": "Etage",
    "searchResidents": "Betreute*r suchen - HIER DRÜCKEN",
    "info": "Info",
    "toilet": "Toilette",
    "searchResult": "Suchergebnis:"
  },
  "weather": {
    "moduleName": "Wetter",
    "metersPerSecond": "m/s"
  },
  "profileSelect": {
    "header": "Wer sind Sie?",
    "description": "Wählen Sie sich selbst aus der Liste aus"
  },
  "profileDetails": {
    "header": "Eingeloggt als",
    "description": "Beschreibung"
  },
  "feedback": {
    "stopRecording": "Aufnahme beenden",
    "addMessage": "Fehler können unten im Textfeld eingegeben werden",
    "message": "Nachricht",
    "maxCharacters": "Maximal 500 Zeichen"
  },
  "emptyStates": {
    "ACTIVITIES": "Keine Aktivitäten",
    "EXTERNAL_ACTIVITIES": "Keine externe Aktivitäten",
    "GALLERY": "Keine Galerien",
    "NEWS": "Keine Neuigkeiten",
    "BOOKING": "Keine Buchungen",
    "MEETINGS": "Keine Treffen",
    "MEAL_PLAN": "Keine Mahlzeiten",
    "WORK_SCHEDULE": "Keine Dienste anzuzeigen",
    "SIMPLE_WORK_SCHEDULE": "Keine Dienste anzuzeigen",
    "LATER_WORK_SCHEDULE": "Keine Dienste anzuzeigen",
    "JOURNEY_PLANNER": "Keine Fahrten",
    "WEATHER": "Keine Wetterdaten",
    "BOOKING_RESOURCES": "Keine Buchungsressourcen",
    "OUR_HOME": "Es gibt nichts zu zeigen",
    "SLIDESHOW": "Keine Slideshows"
  },
  "emptyViews": {
    "Activities": "Keine Aktivitäten",
    "Galleries": "Keine Galerien",
    "News": "Keine Neuigkeiten",
    "Booking": "Keine Ressourcen",
    "Meetings": "Keine Treffen",
    "MealPlan": "Keine Mahlzeiten",
    "WorkSchedule": "Keine Dienste anzuzeigen"
  },
  "rrule": {
    "YEARLY": "Jährlich",
    "MONTHLY": "Monatlich",
    "WEEKLY": "Wöchentlich",
    "DAILY": "Täglich",
    "HOURLY": "Stündlich",
    "MINUTELY": "Jede Minute",
    "SECONDLY": "Jede Sekunde"
  },
  "journeyPlanner": {
    "1Hour": "+1 Stunde",
    "2Hours": "+2 Stunden",
    "30Minutes": "+30 minuten",
    "newTime": "Neue Zeit"
  },
  "meetings": {
    "addSuggestionPinTitle": "Geben Sie Ihren Code ein, um dem Meeting einen Vorschlag hinzuzufügen",
    "optedOut": "Sie sind jetzt vom Meeting abgemeldet.",
    "optOut": "Geben Sie Ihren Code ein, um sich vom Meeting abzumelden.",
    "signedUp": "Sie sind nun für das Meeting registriert.",
    "signUp": "Geben Sie Ihren Code ein, um an der Besprechung teilzunehmen."
  },
  "months": {
    "april": "April",
    "august": "August",
    "december": "Dezember",
    "february": "Februar",
    "january": "Januar",
    "july": "Juli",
    "june": "Juni",
    "march": "März",
    "may": "Mai",
    "november": "November",
    "oktober": "Oktober",
    "september": "September"
  },
  "workSchedule": {
    "cancel": {
      "confirmation": "Der Dienst wurde eingestellt.",
      "title": "Geben Sie Ihren Code ein, um den Dienst für {name} zu kündigen"
    },
    "delete": {
      "confirmation": "Der Dienst wurde gelöscht.",
      "title": "Geben Sie Ihren Code ein, um den Dienst für {name} zu löschen"
    },
    "reactivate": {
      "confirmation": "Der Dienst wurde reaktiviert.",
      "title": "Geben Sie Ihren Code ein, um den Dienst für {name} zu reaktivieren"
    },
    "replace": {
      "confirmation": "Der Dienst wurde ersetzt.",
      "title": "Geben Sie Ihren Code ein, um den Dienst für {name} zu ersetzen"
    }
  }
}
